import { useQuery } from "@tanstack/react-query";
import { DEFAULT_OVERHEAD_PCT } from "@workcost/shared";
import { fetchConfig, fetchPlans, listOrders } from "./billingApi";
import { isMockApi } from "./estimateApi";
import { useApiReady } from "./jobsQueries";
import { sortPlans } from "./plans";

export const plansKey = ["plans"] as const;
export const ordersKey = ["orders"] as const;
export const configKey = ["config"] as const;

/** แพ็กเกจจาก GET /plans (สาธารณะ ไม่ต้องเข้าสู่ระบบ) */
export function usePlans() {
  return useQuery({ queryKey: plansKey, queryFn: async () => sortPlans(await fetchPlans()), staleTime: 60_000 });
}

/** ค่าที่ client ต้องรู้จาก GET /config ถ้าโหลดไม่ได้ใช้ค่าสำรองจาก shared (ไม่ retry เพื่อไม่ให้หน้าผลประเมินรอนาน) */
export function useAppConfig() {
  return useQuery({ queryKey: configKey, queryFn: fetchConfig, staleTime: 10 * 60_000, retry: false });
}

/** ค่าดำเนินการตั้งต้น (%) ที่ใช้เริ่มสถานะแก้ค่า */
export function overheadFrom(cfg: { default_overhead_pct: number } | undefined): number {
  const v = cfg?.default_overhead_pct;
  return typeof v === "number" && Number.isFinite(v) && v >= 0 ? v : DEFAULT_OVERHEAD_PCT;
}

/** ประวัติคำสั่งซื้อ GET /orders (ต้องเข้าสู่ระบบ) */
export function useOrders() {
  const { ready } = useApiReady();
  return useQuery({ queryKey: ordersKey, queryFn: listOrders, enabled: ready || isMockApi(), staleTime: 30_000 });
}
